import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { ObjectStatus } from '../../models/object';
import { OptionService } from '../option.service';

@Component({
  selector: 'cw-object-status',
  templateUrl: './object-status.component.html',
  styleUrls: ['./object-status.component.scss']
})
export class ObjectStatusComponent implements OnInit {
  @Input() status: ObjectStatus;

  constructor(private optionService: OptionService) {
  }

  ngOnInit() {
  }

  @HostBinding('class')
  get className() {
    return 's-' + this.status;
  }

  get name() {
    return this.optionService.objectStatusNames[this.status];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/object-status/object-status.component.ts